var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSuper)?_c('v-sheet',_vm._g(_vm._b({staticClass:"supers pa-3",class:{'outline': _vm.outline}},'v-sheet',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }